import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IFileHistory, defaultValue } from 'app/shared/model/file-history.model';

export const ACTION_TYPES = {
  FETCH_FILEHISTORY_LIST: 'fileHistory/FETCH_FILEHISTORY_LIST',
  FETCH_FILEHISTORY: 'fileHistory/FETCH_FILEHISTORY',
  CREATE_FILEHISTORY: 'fileHistory/CREATE_FILEHISTORY',
  UPDATE_FILEHISTORY: 'fileHistory/UPDATE_FILEHISTORY',
  DELETE_FILEHISTORY: 'fileHistory/DELETE_FILEHISTORY',
  RESET: 'fileHistory/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IFileHistory>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type FileHistoryState = Readonly<typeof initialState>;

// Reducer

export default (state: FileHistoryState = initialState, action): FileHistoryState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_FILEHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_FILEHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_FILEHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_FILEHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_FILEHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_FILEHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_FILEHISTORY):
    case FAILURE(ACTION_TYPES.CREATE_FILEHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_FILEHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_FILEHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_FILEHISTORY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_FILEHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_FILEHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_FILEHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_FILEHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/file-histories';

// Actions

export const getEntities: ICrudGetAllAction<IFileHistory> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_FILEHISTORY_LIST,
  payload: axios.get<IFileHistory>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IFileHistory> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_FILEHISTORY,
    payload: axios.get<IFileHistory>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IFileHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_FILEHISTORY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IFileHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_FILEHISTORY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IFileHistory> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_FILEHISTORY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
